<template>
  <div>
    <a-layout-header
      class="header"
      :style="{
        position: 'fixed',
        zIndex: 1,
        width: '100%',
        background: 'white',
      }"
    >
      <div class="logo" />
      <!-- <a-row :gutter="[24,24]">
      <a-col :span="6"><p>Search</p> <p>occurrence</p> </a-col>
      <a-col :span="6">Search taxonomy</a-col>
      <a-col :span="6">Search age model</a-col>
      <a-col :span="6">Search event calibrations</a-col>
    </a-row> -->
      <a-menu
        class="menu"
        theme="dark"
        v-model="current"
        mode="horizontal"
        :style="{ lineHeight: '64px' }"
        :gutter="[24, 24]"
      >
        <!-- <a-menu-item :span="6">
          <router-link to="/occur">Search occurrence</router-link>
        </a-menu-item> -->

        <a-menu-item :span="6" key="2">
          <router-link to="/home"
            ><img src="../assets/logo2.png" style="height: 64px"
          /></router-link>
        </a-menu-item>
        <a-menu-item :span="6" key="5">
          <router-link to="/strat">Search Stratigraphic Events</router-link>
        </a-menu-item>
        <a-menu-item :span="6" key="3">
          <router-link to="/age">Search Age Model </router-link>
        </a-menu-item>
        <a-menu-item :span="6" key="4">
          <router-link to="/calib">Find Age Range Hole</router-link>
        </a-menu-item>

        <a-menu-item :span="6" key="6">
          <router-link to="/vd">Virtual Drilling </router-link>
        </a-menu-item>

        <a-sub-menu :span="6" key="7">
          <!-- <router-link to="/tools" slot="title">Depth Converter </router-link> -->
          <span slot="title" style="color: rgba(255, 255, 255, 0.65)"
            >Tool</span
          >
          <a-menu-item key="7-1"
            ><router-link to="/tools">Depth Converter </router-link>
          </a-menu-item>
          <a-menu-item key="7-2"
            ><router-link to="/depth">affine & splice</router-link>
          </a-menu-item>
        </a-sub-menu>
        <a-menu-item :span="6" key="8">
          <router-link to="/help">Help </router-link>
        </a-menu-item>
      </a-menu>
    </a-layout-header>
  </div>
</template>

<script>
export default {
  name: 'bannerName',
  data() {
    return {
      current: ['2'],
    };
  },
  methods: {},
  mounted() {
    console.log();
    const path = this.$route.path;
    switch (path) {
      case '/strat':
        this.current = ['5'];
        break;
      case '/home':
        this.current = ['2'];
        break;
      case '/age':
        this.current = ['3'];
        break;
      case '/calib':
        this.current = ['4'];
        break;
      case '/vd':
        this.current = ['6'];
        break;
    }
  },
};
</script>

<style scoped>
.menu {
  font-size: larger;
  /* color: rgb(14, 82, 151); */
  color: white;
  font-weight: bold;
  background-color: #3b5998;
}
.active-class {
  /* color: #1890ff; */
  color: white;
  border-bottom: 2px solid #1890ff;
}
.ant-layout-header {
  padding: 0;
}
.ant-menu.ant-menu-dark .ant-menu-item-selected,
.ant-menu-submenu-popup.ant-menu-dark .ant-menu-item-selected {
  color: white;
  background-color: #3b5998;
}
</style>
